<template @keyup.enter="login">
  <v-card style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);width: 80%;max-width: 500px;">
    <v-card-title class="primary"><span class="headline" style="color: white">登入</span></v-card-title>
    <v-card-text>
      <v-text-field
        v-model="username"
        label="用戶名"
        required
      ></v-text-field>
      <v-text-field
        v-model="password"
        label="密碼"
        type="password"
        required
      ></v-text-field>
      <v-btn @click="login" block color="primary">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'login-view',
  data() {
    return {
      username: null,
      password: null,
    }
  },
  methods: {
    async login() {
      if (this.username && this.password) {
        let success = true
        try {
          await this.$store.dispatch('load', this.$store.dispatch('login', {username: this.username, password: this.password}))
        } catch (e) {
          success = false
        }

        if (!success) return;
        
        this.$router.push({path: this.$route.query.next || '/'})
      }
    },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Login.vue